import React from "react";

export function UserManagementIcon() {
  return (
    <svg width="20" height="9" viewBox="0 0 20 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.65009 4.5C7.65009 6.43332 6.16165 8 4.32489 8C2.48813 8 0.999695 6.43332 0.999695 4.5C0.999695 2.56668 2.48813 1 4.32489 1H4.33028C6.16345 1.00189 7.65009 2.56857 7.65009 4.5Z" stroke="#737FA4" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M7.65594 4.49609H18.9997V7.99609" stroke="#737FA4" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M13.9196 7.99609V4.49609" stroke="#737FA4" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  );
}
